const utils = {
  isSku: () =>
    window.location.href.indexOf('/products/add-sku') !== -1 ||
    window.location.href.indexOf('/products/edit-sku') !== -1,
  isProduct: () =>
    window.location.href.indexOf('/products/add-product') !== -1 ||
    window.location.href.indexOf('/products/edit-product') !== -1,
  isEyeWear: () => window.location.href.indexOf('/eyewear') !== -1,
  isWebModule: () => window.location.href.indexOf('/web-module') !== -1,
  getApiKey: () => {
    return 'SMB-Ojo6NDMzNzE=';
  },
  getModuleSdkUrl: (type, functionType) => {
    const apiKey = utils.getApiKey(functionType);
    return `https://plugins-media.makeupar.com/smb/v4.2-console/sdk.js?apiKey=${apiKey}`;
  },
  loadWebModule: async (type, functionType) => {
    return await new Promise(resolve => {
      const script = document.createElement('script');
      script.src = utils.getModuleSdkUrl(type, functionType);
      script.async = true;
      script.onload = () => resolve();
      document.body.appendChild(script);
    });
  },
  isUniqueUsersUsageAlert: usage => {
    return usage >= 70;
  },
};

export default utils;
